import { render, staticRenderFns } from "./SystemRequirements.vue?vue&type=template&id=1e87da8b&scoped=true"
import script from "./SystemRequirements.vue?vue&type=script&lang=js"
export * from "./SystemRequirements.vue?vue&type=script&lang=js"
import style0 from "./SystemRequirements.vue?vue&type=style&index=0&id=1e87da8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87da8b",
  null
  
)

export default component.exports